import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { processSteps } from '@/constants/company'

export function ProcessSection() {
  return (
    <Section surface="0" withBorder>
      <Container>
        <div className="max-w-2xl mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-fg">
            Engineering Lifecycle
          </h2>
          <p className="mt-2.5 sm:mt-3 text-sm sm:text-base text-fg-subtle">
            A disciplined, transparent delivery framework designed to eliminate guesswork from kickoff to production.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {processSteps.map((step) => (
            <div
              key={step.step}
              className="flex flex-col p-5 sm:p-6 rounded-sm bg-surface-2 border border-border-subtle"
            >
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <span className="font-mono text-xs font-semibold px-2 py-0.5 rounded-xs bg-surface-3 text-fg">
                  Phase 0{step.step}
                </span>
              </div>
              <h3 className="text-base font-semibold text-fg mb-1.5 sm:mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-fg-subtle leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
